import { render } from "./PortfolioContainer.vue?vue&type=template&id=1c64b7e2"
import script from "./PortfolioContainer.vue?vue&type=script&lang=js"
export * from "./PortfolioContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__